import { isNil } from '../../common/utils/isNil'

export const isJson = (value: unknown) => {
  if (isNil(value)) {
    return false
  }

  try {
    const parsed = JSON.parse(value as string)

    return typeof parsed === 'object'
  } catch {
    return false
  }
}
